import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

export enum PollState {
  InCreation,
  VotingOpen,
  VotingClosed,
  ResultsAvailable,
  Over
}

export class PollOption {
  public name: string = '';
}

export class Poll {
  public id: string = '';
  public state: PollState = PollState.InCreation;
  public question: string = '';
  public winner: number | null = null;
  public options: PollOption[] = [];
  public results: number[] = [];
  public totalVotes: number = 0;

  public empty() {
    this.id = '';
    this.state = PollState.InCreation;
    this.question = '';
    this.winner = null;
    this.options = [];
  }
}

export class ChannelSettings {
  public accentColor: string = '#6441a4';
  public textColor: string = '#ffffff';
  public poll: Poll | null = null;
}

@Module({ namespaced: true, name: 'polls' })
export default class PollsStore extends VuexModule {
  public settings: ChannelSettings = new ChannelSettings();
  public viewerVote: number | null = null;

  // Controls for live poll creation UI.
  public maxQuestionChars: number = 80;
  public starterOptionChars: number = 80;
  public optionCharsDecrease: number = 5;
  public maxPollOptions: number = 6;

  @Mutation
  public setPoll(poll: Poll) {
    this.settings.poll = poll;
  }

  @Mutation
  public setAccentColor(color: string) {
    this.settings.accentColor = color;
  }

  @Mutation
  public setTextColor(color: string) {
    this.settings.textColor = color;
  }

  @Mutation
  public setChannelState(settings: ChannelSettings) {
    if (settings.accentColor) {
      this.settings.accentColor = settings.accentColor;
    }
    if (settings.textColor) {
      this.settings.textColor = settings.textColor;
    }

    this.settings.poll = settings.poll;
  }

  @Mutation
  public setViewerVote(vote: number | null) {
    this.viewerVote = vote;
  }

  @Mutation
  public clearViewerVote() {
    this.viewerVote = null;
  }

  @Mutation
  public setMaxQuestionChars(chars: number) {
    this.maxQuestionChars = chars;
  }

  @Mutation
  public setStarterOptionChars(chars: number) {
    this.starterOptionChars = chars;
  }

  @Mutation
  public setOptionCharsDecrease(chars: number) {
    this.optionCharsDecrease = chars;
  }

  @Mutation
  public setMaxPollOptions(options: number) {
    this.maxPollOptions = options;
  }

  @Action
  public async saveChannelState(sdk: any) {
    // NOTE: According to the vuex-module-decorators docs, `this` should refer to the PollsStore
    // object. However `Actions` at runtime seem to be bound to the namespaced store object
    // instead. So we have to access state variables at `this.state.<whatever>`.
    return sdk.setChannelState((this.state as any).settings);
  }
}
